import { render, staticRenderFns } from "./TheFormsApp.vue?vue&type=template&id=3d539472&"
import script from "./TheFormsApp.vue?vue&type=script&lang=js&"
export * from "./TheFormsApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports